import React, { useState, useEffect, useCallback } from "react";
import Spinner from "../../0. Utilidades/loadingSpinner";
import userIcon from "../../../static/user_icon.png";

const CommentAuthor = ({ author }) => {
  if (!author) return null;

  return (
    <img
      className="comment-author-avatar"
      src={author.image || userIcon}
      alt={author.name || "Usuario"}
      title={author.name || author.username || "Usuario"}
    />
  );
};

const CommentsSection = ({ maestraRut }) => {
  const [newComment, setNewComment] = useState("");
  const [comments, setComments] = useState([]); // Initialize as an empty array
  const [isLoading, setIsLoading] = useState(true); // State to handle loading

  // Fetch CSRF token for secure requests
  const fetchCSRFToken = async () => {
    const apiUrlcsrf = `${process.env.REACT_APP_BASE_API}api/csrf_token/`;
    const response = await fetch(apiUrlcsrf, { credentials: "include" });
    const data = await response.json();
    return data.csrfToken;
  };

  // Function to fetch comments from the server
  const fetchComments = useCallback(async () => {
    setIsLoading(true);
    const apiUrl = `${process.env.REACT_APP_BASE_API}api/perfiles/maestras/${maestraRut}/comentarios/`;
    try {
      const response = await fetch(apiUrl);
      const data = await response.json();
      setComments(data); // Ensure data is an array
    } catch (error) {
      console.error("Error fetching comments:", error);
      setComments([]); // Set to empty array in case of error
    } finally {
      setIsLoading(false);
    }
  }, [maestraRut]);

  // Submit new comment
  const handleCommentSubmit = async () => {
    if (!newComment.trim()) {
      alert("Por favor, ingrese un comentario antes de enviar.");
      return;
    }

    const csrfToken = await fetchCSRFToken();
    const postData = {
      maestra: maestraRut,
      comment_text: newComment,
    };

    const apiUrl = `${process.env.REACT_APP_BASE_API}api/perfiles/comentarios/`;
    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": csrfToken,
      },
      body: JSON.stringify(postData),
      credentials: "include",
    })
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((data) => {
        console.log("Success:", data);
        setNewComment(""); // Clear the textarea after successful submission
        fetchComments(); // Refetch comments to ensure list is up-to-date
      })
      .catch((error) => console.error("Error:", error));
  };

  // Initial fetching of comments on component mount or when maestraRut changes
  useEffect(() => {
    fetchComments();
  }, [fetchComments]); // Fetch comments when maestraRut changes

  return (
    <div className="maestra-info">
      <h5>Comentarios</h5>

      <textarea
        className="form-control"
        placeholder="Añadir un comentario..."
        value={newComment}
        onChange={(e) => setNewComment(e.target.value)}
      />
      <button onClick={handleCommentSubmit} className="btn btn-primary">
        Enviar
      </button>

      <h5>Comentarios Subidos</h5>
      {isLoading ? (
        <Spinner />
      ) : comments && comments.length > 0 ? (
        comments.map((comment, index) => {
          return (
            <div key={index} className="maestra-comentario">
              <p>{comment.comment_text}</p>
              <div className="comment-meta-row">
                <CommentAuthor author={comment.created_by_user} />
                <span>✔️✔️ {comment.date_observed}</span>
              </div>
            </div>
          );
        })
      ) : (
        <p>No hay comentarios aún.</p>
      )}
    </div>
  );
};

export default CommentsSection;
